import { Component, OnInit } from '@angular/core';
import { ProductLine } from '../../opc-app/productline/productline.model';
import { Message } from 'primeng/api';
import { OPCConstant } from '../../opc-app/opc.const';
import { ProductService } from '../../shared/services/product.service';
import { NotificationService } from '../../shared/services/notification.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-productline',
    templateUrl: './productline.component.html'
})
export class ProductLineComponent implements OnInit {
    startIndex: number;
    endIndex: number;
    productLines: ProductLine[];
    added: boolean;
    newProductLine: ProductLine;
    notifications: Message[] = [];
    loading = false;
    pagedItems: any;

    constructor(private _productService: ProductService, private notifyService: NotificationService, private spinner: NgxSpinnerService) { }
    ngOnInit(): void {
        this.loading = true;
        this.spinner.show();
        this.getAllProductLines();
    }
    getAllProductLines() {
        this._productService.getAllProductLines().subscribe(res => {
            this.productLines = res;
            this.spinner.hide();
            this.loading = false;
        });
    }
    setPageData(data: any) {
        this.pagedItems = this.productLines.slice(data.startIndex, data.endIndex);
        this.startIndex = data.startIndex;
        this.endIndex = data.endIndex;
    }
    onSubmit(event) {
        if (event) {
            this.added = false;
            this.newProductLine = new ProductLine();
            const pl = this.productLines.find(p => p.productLineID === event.productLineID);
            if (pl) {
                const index = this.productLines.indexOf(pl);
                this.productLines[index] = event;
                this.notifications = this.notifyService.growlNotification('succ', OPCConstant.UPDATE_SUCCESS);
            } else {
                this.productLines.unshift(event);
                this.notifications = this.notifyService.growlNotification('succ', OPCConstant.UPDATE_SUCCESS);
            }
            this.pagedItems = this.productLines.slice(this.startIndex, this.endIndex);
        }
    }
    onDelete(event, item) {
        if (event && item) {
            const index = this.productLines.indexOf(item);
            this.productLines.splice(+index, 1);
            this.notifications = this.notifyService.growlNotification('succ', OPCConstant.DELETE_SUCCESS);
        } else {
            this.added = false;
        }
    }
    onAddNew() {
        this.added = true;
        this.newProductLine = new ProductLine();
    }
}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/productline/productline.component.ts